
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Our History & Commitment to Excellence
            </h2>
            <div className="space-y-4 text-gray-600 text-lg">
              <p>
                Thorn Ford Dental Laboratory was founded in 1977 by a group of experienced technicians who left the corporate environment of Harrison Dental Lab to build an independent, innovation-driven laboratory. From day one, our focus has been on quality craftsmanship, responsive service, and strong partnerships with clinicians.
              </p>
              <p>
                Today, we operate as a mid-sized, full-service dental lab, offering a wide range of restorative solutions, including:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Full-arch implant restorations (All-on-X)</li>
                <li>Full and partial dentures (digital and analog)</li>
                <li>Crowns, bridges, and veneers</li>
                <li>Provisionals and custom implant abutments/bars</li>
                <li>Attachments, night guards, and sleep appliances</li>
                <li>Digital design and chairside support</li>
              </ul>
              <p>
                We specialize in full-arch implant cases and offer chairside assistance to ensure predictable outcomes and seamless workflow integration. Whether you're working analog or digital, we're here to support your clinical goals with technical expertise and consistent results.
              </p>
              <p>
                At Thorn Ford, we're more than a lab — we're your partner in delivering high-quality, patient-specific prosthetics backed by decades of experience and a collaborative approach to care.
              </p>
            </div>

            {/* Statistics */}
            <div className="grid grid-cols-2 gap-6 mt-8">
              <div className="text-center p-4 bg-blue-50 rounded-lg">
                <div className="text-3xl font-bold text-blue-600">2,500+</div>
                <div className="text-sm text-gray-600">Dental Practices Served</div>
              </div>
              <div className="text-center p-4 bg-blue-50 rounded-lg">
                <div className="text-3xl font-bold text-blue-600">48</div>
                <div className="text-sm text-gray-600">Years of Excellence</div>
              </div>
              <div className="text-center p-4 bg-blue-50 rounded-lg">
                <div className="text-3xl font-bold text-blue-600">50,000+</div>
                <div className="text-sm text-gray-600">Devices Manufactured</div>
              </div>
              <div className="text-center p-4 bg-blue-50 rounded-lg">
                <div className="text-3xl font-bold text-blue-600">98%</div>
                <div className="text-sm text-gray-600">Client Satisfaction</div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/8f395696f639d0b4fdbfe8a2d37f0b58.jpg"
              alt="Our History and Growth"
              className="w-full h-[600px] object-cover object-top rounded-xl shadow-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
